import useSWR from 'swr'
import { staticOptions } from 'src/lib/core/api-client'
import { getAppDetailV2 } from 'src/lib/core/api-methods'
import { V2UnifiedAppDetail } from 'src/lib/types/appsIntegrations'
import { v2UnifiedAppDetailFromApi } from 'src/lib/utils/appsIntegrationsHelpers'
import { useUser } from 'src/lib/contexts/UserContext'
import { permissionType } from 'src/lib/utils/constants'

interface AppDetailV2Response {
  success: boolean
  data: V2UnifiedAppDetail
}

export const useAppDetailV2 = (appId: string | undefined) => {
  const { canAccess } = useUser()
  const { data, isLoading, error, mutate } = useSWR<AppDetailV2Response>(
    appId ? `/flo-settlement/api/v2/apps/${appId}` : null,
    () => getAppDetailV2(appId!) as unknown as Promise<AppDetailV2Response>,
    staticOptions
  )

  const shopPassEnabled = canAccess(permissionType.TAB_SSO, 0)

  const detail = data?.data ? v2UnifiedAppDetailFromApi(data.data, { shopPassEnabled }) : undefined

  return { detail, isLoading, error, mutate }
}
